import { MyDocumentsUrl } from "../directives/utilities/urls";

export default function uploadDocument() {
    return {
        peopleCodeId: '',
        file: null,
        selectedOffice: '',
        selectedDocumentTypeCode: '',
        selectedDocumentType: '',
        notes: '',
        status: '',
        offices: [],
        fetchedDocumentTypes: '',
        isFileValid: false,
        isOfficeCode: false,
        errorisOfficeCode: '',
        isDocumentTypeCode: false,
        errorisDocumentTypeCode: '',
        isNotes: false,
        errorisNotes: '',
        errorLable: '',
        fileName: '',
        documentStatus: '',
        fileSelected: '',
        documentsList: [],
        passedPeopleCodeId: '',
        isSuccessMessage: false,
        isSubmitting: false,
        fetchOffices() {
            fetch(' /api/Document/GetDocumentOffices')
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                })
                .then((response) => {
                    this.offices = response.offices;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        bindStudentDocumentsList() {

            this.passedPeopleCodeId = document.getElementById("peopleCodeId").value;

            fetch("/api/Document/GetStudentDocumentsListByDocumentId?peopleCodeId=" +
                this.passedPeopleCodeId +
                "&documentId=" +
                document.getElementById('documentIdFromQueryString').value,
                { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        Array.prototype.push.apply(this.documentsList, response.documents)
                        this.fileName = this.documentsList[0].fileName;
                        this.notes = this.documentsList[0].notes;
                        this.selectedOffice = this.documentsList[0].office;
                        this.fetchDocumentTypes(this.documentsList[0].documentCode);
                        this.selectedDocumentType = this.documentsList[0].documentType;
                    } else {
                        this.isSuccessMessage = false;
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
        fetchDocumentTypes(selectedDocument) {

            const apiUrl = `/api/Document/GetDocumentTypes?officeType=` + this.selectedOffice;

            fetch(apiUrl)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                })
                .then((response) => {
                    this.fetchedDocumentTypes = response.documenTypes;
                    if (selectedDocument != '') {
                        this.selectedDocumentTypeCode = selectedDocument;
                    }

                })
                .catch((error) => {
                    console.error(error);
                });
        },
        fetchDocumentTypesForOffice() {

            const apiUrl = `/api/Document/GetDocumentTypes?officeType=` + this.selectedOffice;

            fetch(apiUrl)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                })
                .then((response) => {
                    this.fetchedDocumentTypes = response.documenTypes;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        validateFileInput(event) {
            this.file = event.target.files[0];
            if (this.file) {
                this.fileSelected = this.file.name;
                if (this.file.size > 4 * 1024 * 1024) { // 4MB limit
                    this.isFileValid = false;
                    this.errorLable = "File size should be less than 4MB";
                    this.isSubmitting = false;
                }
                else {
                    const allowedExtensions = ["doc", "docx", "gif", "jpg", "jpeg", "pdf"];
                    const fileExtension = this.file.name.split('.').pop();
                    if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
                        this.isFileValid = false;
                        this.errorLable = "Allowed file types are: doc, docx, gif, jpg, jpeg, pdf";
                        this.isSubmitting = false;
                    } else {
                        this.isFileValid = true;
                    }
                }

            }

        },
        uploadFile() {
            this.isSubmitting = true;
            if (this.fileSelected == "")
            {
                this.isFileValid = false;
                this.errorLable = "Please select file";
                this.isSubmitting = false;
            }
            else if (this.file.size > 4 * 1024 * 1024)
            { // 4MB limit
                this.isFileValid = false;
                this.errorLable = "File size should be less than 4MB";
                this.isSubmitting = false;
            }
            else
            {
                const allowedExtensions = ["doc", "docx", "gif", "jpg", "jpeg", "pdf"];
                const fileExtension = this.file.name.split('.').pop();
                if (!allowedExtensions.includes(fileExtension.toLowerCase()))
                {
                    this.isFileValid = false;
                    this.errorLable = "Allowed file types are: doc, docx, gif, jpg, jpeg, pdf";
                    this.isSubmitting = false;
                } else
                {
                    this.isFileValid = true;
                }
            }
            
           
            
            if (this.selectedOffice == "") {
                this.isOfficeCode = false;
                this.errorisOfficeCode = "Please select office";
                this.isSubmitting = false;
            }
            else {
                this.isOfficeCode = true;
            }
            if (this.selectedDocumentTypeCode == "") {
                this.isDocumentTypeCode = false;
                this.errorisDocumentTypeCode = "Please select document type";
                this.isSubmitting = false;
            }
            else {
                this.isDocumentTypeCode = true;
            }
            if (this.notes == "") {
                this.isNotes = false;
                this.errorisNotes = "Please add comments";
                this.isSubmitting = false;
            }
            else {
                this.isNotes = true;
            }
            let formData = new FormData();
            formData.append("peopleCodeId", document.getElementById('peopleCodeId').value);
            formData.append("documentId", document.getElementById('documentIdFromQueryString').value);
            formData.append("file", this.file);
            formData.append("selectedOffice", this.selectedOffice);
            formData.append("selectedDocumentTypeCode", this.selectedDocumentTypeCode);
            formData.append("selectedDocumentType", this.selectedDocumentType);
            formData.append("notes", this.notes);
            //formData.append("status", this.status);
            fetch("/api/Document/UploadDocument", {
                method: "POST",
                body: formData,
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    this.isSubmitting = false;
                    if (response.isSuccess) {
                       
                        this.isSuccessMessage = true;
                        window.location.href = MyDocumentsUrl;
                       // this.documentStatus = response.messages[0]
                    } else {
                        this.isSuccessMessage = false;
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },

        init() {
            this.fetchOffices();
            if (document.getElementById('documentIdFromQueryString').value > 0) {
                this.bindStudentDocumentsList();
            }
            this.documentStatus = this.documentStatus ? this.documentStatus : "";
            this.fileSelected = this.fileSelected ? this.fileSelected : "";
        }
    }
}